import { useState, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import "dayjs/locale/ko";
import dayjs, { Dayjs } from "dayjs";

export default function Calender({
  setSelectedDate,
}: {
  setSelectedDate: React.Dispatch<React.SetStateAction<string | undefined>>;
}) {
  const [value, setValue] = useState<Dayjs | null>(dayjs());

  useEffect(() => {
    setSelectedDate(value?.format("YYYY-MM-DD"));
  }, [value]);

  return (
    <div
      onClick={() => {
        setTimeout(() => {
          var yearPicker = document.getElementsByClassName(
            "MuiYearCalendar-root css-1n9wbkw-MuiYearCalendar-root"
          );
          Array.prototype.forEach.call(yearPicker, (element) => {
            var el = element as HTMLElement;
            el.style.width = "100%";
          });
        }, 0);
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
        <DateCalendar
          value={value}
          onChange={(newValue) => setValue(newValue)}
          sx={{ width: "100%" }}
        />
      </LocalizationProvider>
    </div>
  );
}
